export const sortAlphabetically = <T>(elems: T[], sortStringGetter: (item: T) => any) =>
    [...elems].sort((a, b) => {
        const textA = String(sortStringGetter(a) ?? "").toLowerCase();
        const textB = String(sortStringGetter(b) ?? "").toLowerCase();
        if (textA < textB) return -1;
        if (textA > textB) return 1;
        return 0;
    });

export const sortAlphabeticallyByProperty = <T>(list: T[], property: string) => {
    return sortAlphabetically([...(list || [])], (listItem) => listItem[property]);
};
